import { AxiosResponse } from 'axios';
import { getMessageError } from 'utils/helpers';

import { api } from 'services/api';

import { Chat } from './types';

const getChat = async () => {
  try {
    return await api.get<void, AxiosResponse<Chat>>(`/v1/specialist/chats`);
  } catch (e) {
    throw new Error(
      getMessageError(e, 'Unexpected error while retrieving chat information'),
    );
  }
};

export { getChat };
